import axios from 'axios';
import { getDomainConfig } from 'utils/whiteLabel';
import { curlLogger } from 'utils/apiLogger';
import { forceSessionExpired } from 'utils/tokenExpirationHelper';
import { getActiveToken, getTabId } from 'utils/tabAuth';

const config = getDomainConfig();

export const socketAPI = `${config.apiUrl}/`;

export const baseURL = `${config.apiUrl}/v1`;

const api = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

// IMPORTANT: Axios request interceptors run in LIFO order (last added runs first)
// So we add curlLogger FIRST (runs second) and auth SECOND (runs first)

api.interceptors.request.use(curlLogger.request);

// Add Authorization + per-tab edit-session headers to all requests automatically
api.interceptors.request.use(config => {
  const token = getActiveToken();
  config.headers = config.headers || {};
  if (token) {
    config.headers['Authorization'] = token;
  }
  // Identifies this tab to the AI Studio single-editor lock (backend ignores it elsewhere).
  config.headers['x-edit-session-id'] = getTabId();
  return config;
});

api.interceptors.response.use(curlLogger.response, curlLogger.error);

// Global session-revocation handler: if ANY request comes back 401 with the
// "Session has been logged out" message (the session was revoked on another
// device or by an admin), pop the session-expired dialog and log out here too.
api.interceptors.response.use(
  response => response,
  error => {
    if (
      error?.response?.status === 401 &&
      error?.response?.data?.errorMessage === 'Session has been logged out'
    ) {
      forceSessionExpired();
    }
    return Promise.reject(error);
  },
);

export default api;
